<template>
  <v-container>
    <v-layout style="display: flex">
      <v-progress-circular
        indeterminate
        class="loading"
        color="primary"
        v-if="loading"
      >
        Cargando
      </v-progress-circular>
      <v-flex v-else>
        <v-list v-for="(error, err) in errors.arr" :key="err">
          <v-alert
            v-if="errors.arr.length"
            border="top"
            color="red lighten-2"
            >{{ error }}</v-alert
          >
        </v-list>
        <v-card elevation="2" color="#f0f2f5" style>
          <!-- sections for form -->

          <v-list
            v-for="(section, s) in questions"
            :key="s"
            style="max-width: 100%; margin-left: 5%; margin-right: 5%"
          >
            <v-card v-if="section.questions.length" color="#f0f2f6">
              <v-card-title
                class="question"
                style="margin-left: 5%; font-size: 200%; font-weight: bold"
                >{{ section.title }}</v-card-title
              >

              <!-- Questions it self -->
              <v-list
                v-for="(question, i) in section.questions"
                :key="i"
                :rules="[rules.required]"
                style="max-width: 100%; margin-left: 5%; margin-right: 5%"
              >
                <v-list-item-content
                  v-if="LoadQuestion(question, answers, final)"
                >
                  <!-- Questions  -->
                  <selectAnswerComponentTextVue
                    class="question"
                    :question="question"
                    v-if="isSelectQuestion(question)"
                    v-on:selectAnswer="registerAnswer"
                    :questionNumber="getNum(question)"
                    v-on:addconstOther="addconstOther"
                    v-on:addEvidence="addEvidence"
                    v-on:addOptionText="addOptionText"
                    v-on:addEvidenceDroped="addEvidenceDroped"
                  />
                  <multiAnswerComponentVue
                    class="question"
                    :question="question"
                    v-if="isCheckQuestion(question)"
                    v-on:selectAnswerMulti="registerMultiAnswer"
                    v-on:addOptionText="addOptionText"
                    :questionNumber="getNum(question)"
                  />
                  <textAnswerVue
                    :question="question"
                    class="question"
                    v-if="isNumericQuestion(question)"
                    v-on:selectAnswer="registerAnswer"
                    :questionNumber="getNum(question)"
                    :numeric="true"
                  />
                  <textAnswerVue
                    :question="question"
                    class="question"
                    v-if="isTextQuestion(question)"
                    v-on:selectAnswer="registerAnswer"
                    :questionNumber="getNum(question)"
                  />
                  <tableAnswerComponentVue
                    :question="question"
                    class="question"
                    :key="getNum(question)"
                    v-if="isTableQuestion(question)"
                    v-on:selectTableAnswer="registerTable"
                    :questionNumber="getNum(question)"
                  />
                  <dropAnswerComponentVue
                    :key="question.number + reloadCount[getNum(question)]"
                    :question="question"
                    :options="option.get(getNum(question))"
                    class="question"
                    v-if="isDropQuestion(question)"
                    v-on:changedAnswer="registerAndUpdateOptions"
                    :questionNumber="getNum(question)"
                  />
                </v-list-item-content>
              </v-list>
            </v-card>
          </v-list>
          <finalInfoComponentVue
            style="width: 90%; margin-left: 5%; margin-right: 5%"
            v-on:changeFilling="setFilling"
            v-on:changeLifting="setLifting"
          />
          <evidence-vue
            style="width: 90%; margin-left: 5%; margin-right: 5%"
            v-on:addEvidence="addEvidence"
            v-on:addEvidenceDroped="addEvidenceDroped"
          />
        </v-card>

        <v-card style="margin-top: 2em; margin-bottom: 2em">
          <div
            id="evidences"
            v-for="evidence in evidences"
            :key="evidence.name"
          >
            <v-row>
              <label style="margin-left: 2%; padding-top: 1%">
                {{ evidence.name }}</label
              >
              <v-spacer></v-spacer>
              <v-icon style="margin-right: 2%" @click="removeFile(evidence)"
                >mdi-delete</v-icon
              >
            </v-row>
          </div>
        </v-card>
        <v-btn
          @click="
            createRegister(
              questions,
              answers,
              final,
              evidences,
              liftingDate,
              fillingResponsable,
              errors,
              $router
            )
          "
          right
          width="100%"
          height="50px"
          min-height="30px"
          elevation="20"
          color="#015CAB"
          style="margin-top: 1%; margin-bottom: 10%; color: white"
          :disabled="buttonClicked"
          >Enviar</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  getQuestions,
  getAuxiliarByTypeWithDependency,
} from "@/utils/apiRequest.js";
import textAnswerVue from "@/components/textAnswer.vue";
import selectAnswerComponentTextVue from "@/components/selectAnswerComponentText.vue";
import multiAnswerComponentVue from "@/components/multiAnswerComponentText.vue";
import tableAnswerComponentVue from "@/components/tableAnswerComponent.vue";
import dropAnswerComponentVue from "@/components/dropAnswerComponent.vue";
import finalInfoComponentVue from "@/components/finalInfoComponent.vue";
import evidenceVue from "@/components/fileUpload.vue";
import Vue from "vue";
import {
  LoadQuestion,
  isDropQuestion,
  isTableQuestion,
  isCheckQuestion,
  isTextQuestion,
  hasSpecifyText,
  isSelectQuestion,
  isNumericQuestion,
  createRegister,
} from "@/utils/utils";
export default {
  data() {
    return {
      buttonClicked:false,
      constconstOther: "Other",
      prevQuestions: 0,
      questions: [],
      answers: [],
      parsedResponse: new Map(),
      final: new Map(),
      demo: false,
      domain: "",
      name: "",
      loading: true,
      goal: "",
      obunit: "",
      errors: {
        arr: [],
      },
      reloadCount: {},
      domainDrop: [],
      subdomainDrop: [],
      liftingDate: "",
      fillingResponsable: "",
      evidences: [],
      option: new Map(),
      rules: {
        required: (v) => !!v || "This field is required",
      },
    };
  },

  computed: {},
  components: {
    textAnswerVue,
    multiAnswerComponentVue,
    selectAnswerComponentTextVue,
    tableAnswerComponentVue,
    evidenceVue,
    dropAnswerComponentVue,
    finalInfoComponentVue,
  },
  methods: {
    setFilling({ value }) {
      this.fillingResponsable = value;
    },
    setLifting({ value }) {
      this.liftingDate = value;
    },
    addEvidence({ file }) {
      this.evidences.push(file);
    },

    addEvidenceDroped({ file }) {
      this.evidences.push(file);
    },
    registerTable({ number, answer }) {
      Vue.set(this.answers, number, answer);
      this.answers[number] = answer;
    },
    registerMultiAnswer({ number, answer }) {
      let saved = this.final.get(number);
      let tempAns = this.answers[number];

      if (saved == undefined) {
        if (tempAns == undefined) {
          answer = answer.replace("undefined", "");
          this.answers[number] = answer;
          Vue.set(this.answers, number, answer);
          return;
        }

        if (answer == "Otro, especifique" || answer == "Otra, especifique") {
          answer = this.getOtherValue(tempAns, answer);
          answer = answer.replace("undefined", "");
        }

        let tempAnsArr = tempAns.split(";");
        let index = tempAnsArr.indexOf("");
        while (index != -1) {
          tempAnsArr.splice(index, 1);
          index = tempAnsArr.indexOf("");
        }

        if (tempAnsArr.includes(answer)) {
          let index = tempAnsArr.indexOf(answer);
          while (index != -1) {
            tempAnsArr.splice(index, 1);
            index = tempAnsArr.indexOf(answer);
          }
        } else {
          tempAnsArr.push(answer);
        }

        let newAnswer = "";
        tempAnsArr.forEach((field) => {
          newAnswer += field + ";";
        });

        newAnswer = newAnswer.replace("undefined", "");

        Vue.set(this.answers, number, newAnswer);
        this.answers[number] = newAnswer;
        return;
      }

      if (saved.answer == undefined) {
        saved = {
          question: number,
          answer: answer,
        };
      }

      if (answer == "Otro, especifique" || answer == "Otra, especifique") {
        answer = this.getOtherValue(saved.answer, answer);
      }

      let tempAnsArr = saved.answer.split(";");

      let index = tempAnsArr.indexOf("");
      while (index != -1) {
        tempAnsArr.splice(index, 1);
        index = tempAnsArr.indexOf("");
      }

      if (tempAnsArr.includes(answer)) {
        let index = tempAnsArr.indexOf(answer);
        while (index != -1) {
          tempAnsArr.splice(index, 1);
          index = tempAnsArr.indexOf(answer);
        }
      } else {
        tempAnsArr.push(answer);
      }

      let newAnswer = "";

      tempAnsArr.forEach((field) => {
        newAnswer += field + ";";
      });

      newAnswer = newAnswer.replace("undefined", "");
      saved.answer = newAnswer;

      this.answers[number] = saved.answer;
      this.final.set(number, saved);
    },

    getOtherValue(fullAnswer, ans) {
      if (fullAnswer.includes(ans)) {
        let startIndex = fullAnswer.search(ans) + ans.length;
        let word = ans;
        for (let index = startIndex; index < fullAnswer.length; index++) {
          if (fullAnswer[index] == ";") {
            break;
          }

          word += fullAnswer[index];
        }
        return word;
      }

      return ans;
    },

    getOtherValueAlone(fullAnswer) {
      let startIndex = fullAnswer.search("Otro, especifique");
      if (startIndex == -1) {
        startIndex = fullAnswer.search("Otra, especifique");
      }
      let word = "";
      for (let index = startIndex; index < fullAnswer.length; index++) {
        if (fullAnswer[index] == ";") {
          break;
        }

        word += fullAnswer[index];
      }
      return word;
    },
    registerAnswer({ number, answer }) {
      Vue.set(this.answers, number, answer);
      if (
        this.final.get(number) == undefined ||
        this.final.get(number).answer == undefined
      ) {
        this.answers[number] = answer;
        return;
      }

      this.answers[number] = "other";
      let response = answer.split(";");
      let prevQuestions = [];
      let added = [];

      this.final
        .get(number)
        .answer.split(";")
        .forEach((ans) => {
          response.forEach((incoming) => {
            if (ans.includes(incoming)) {
              prevQuestions.push(ans);
              added.push(incoming);
            }
            if (!ans.includes(incoming) && !added.includes(incoming)) {
              prevQuestions.push(incoming);
              added.push(incoming);
            }
          });
        });
      let tempResponse = prevQuestions[0];

      prevQuestions.forEach((ans) => {
        if (ans != prevQuestions[0] && ans != undefined) {
          tempResponse += ";" + ans;
        }
      });
      if (tempResponse != undefined) response = tempResponse;

      this.final.set(number, {
        question: this.final.get(number).question,
        answer: response,
      });
    },

    async registerAndUpdateOptions({ number, answer }) {
      Vue.set(this.answers, number, answer);
      this.answers[number] = answer;
      if (number == "1.5") {
        let response = await getAuxiliarByTypeWithDependency(
          "Subdominio de la actividad estadística",
          answer
        );
        if (response.data.status == "success") {
          let subdomains = [];
          response.data.auxiliar.forEach((aux) => {
            subdomains.push(aux.value);
          });

          this.option.set("1.6", subdomains);
          this.reloadCount["1.6"] += 1;
          let found = false;
          this.questions.forEach((sector) => {
            if (found) {
              return;
            }
            sector.questions.forEach((question) => {
              if (found) {
                return;
              }
              if (this.getNum(question) == "1.6") {
                found = true;
                question.number = "5";
                question.number = "6";
              }
            });
          });
        }
      }
    },
    addconstOther({ number, answer, question }) {
      Vue.set(this.answers, number, "constOther");
      this.answers[number] = "constOther";
      this.final.set(number, {
        question: question,
        answer: answer.target._value,
      });
    },
    addOptionText({ number, answer, question, option }) {
      let response = option + ":" + answer.target._value;
      if (this.final.get(number) == undefined) {
        if (this.answers[number].split(";").length > 0) {
          response = this.answers[number] + response;
        }
        this.final.set(number, {
          question: question.question,
          answer: response,
        });

        return;
      }

      if (
        this.final.get(number) != undefined &&
        !question.type.toUpperCase().includes("MULTI")
      ) {
        this.final.get(number).answer = ""; // if it's not a multi answer, delete the previous value
      }

      if (
        this.final.get(number).answer.includes("Otro, especifique") ||
        this.final.get(number).answer.includes("Otra, especifique")
      ) {
        this.final.get(number).answer = this.final
          .get(number)
          .answer.replace(
            this.getOtherValue(this.final.get(number).answer) + ";",
            ""
          );
      }

      if (this.final.get(number) != undefined) {
        this.final.get(number).answer = this.final
          .get(number)
          .answer.replace("undefined", "");

        let ansArr = this.final.get(number).answer.split(";");

        let cleanedAnswers = [];
        ansArr.forEach((ans) => {
          if (!response.includes(ans) && ans != undefined) {
            cleanedAnswers.push(ans);
          }
        });
        let tempResponse = "";

        cleanedAnswers.forEach((ans) => {
          if (ans != undefined) {
            tempResponse += ans + ";";
          }
        });

        response = tempResponse + response + ";";
      }

      this.final.set(number, {
        question: question.question,
        answer: response,
      });

      Vue.set(this.answers, number, "other");
      this.answers[number] = "other";
    },

    getNum(question) {
      return question.section.toString() + "." + question.number;
    },
    isDropQuestion: isDropQuestion,
    isTableQuestion: isTableQuestion,
    isCheckQuestion: isCheckQuestion,
    isTextQuestion: isTextQuestion,
    hasSpecifyText: hasSpecifyText,
    isSelectQuestion: isSelectQuestion,
    isNumericQuestion: isNumericQuestion,
    async createRegister(questions, answers, final, evidences, liftingDate, fillingResponsable, errors, router){
      this.buttonClicked = true;
      setTimeout(()=> this.buttonClicked = false,3000);
      await createRegister(questions, answers, final, evidences, liftingDate, fillingResponsable, errors, router);
    },
    removeFile(file) {
      let evidenceIndex = this.evidences.indexOf(file);
      //remove car from the colors array
      this.evidences.splice(evidenceIndex, 1);
    },
    prepareDropDown() {
      let questionArray = ["1.3", "1.5", "1.6", "1.7"];
      this.questions.forEach((sector) => {
        if (questionArray.length == 0) {
          return;
        }
        sector.questions.forEach((question) => {
          if (questionArray.length == 0) {
            return;
          }
          if (questionArray.includes(this.getNum(question))) {
            let options = question.options.split(";");
            this.option.set(this.getNum(question), options);
            this.reloadCount[this.getNum(question)] = 0;
            const index = questionArray.indexOf(this.getNum(question));
            if (index > -1) {
              questionArray.splice(index, 1);
            }
          }
        });
      });
    },
    LoadQuestion: LoadQuestion,
  },
  async setup() {},
  async created() {},

  async mounted() {
    let response = await getQuestions();
    if (response.data.status == "success") {
      this.questions = response.data.sections;
    }
    this.prepareDropDown();
    this.loading = false;
  },
};
</script>

<style scoped>
.question {
  overflow-wrap: break-word;
  word-break: normal;
}

.dropzone {
  width: 100%;
  height: 60%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.4s ease all;
  background-color: #d0c8c8;
}

.active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #41b883;
}

.labelButton {
  padding: 1% 1%;
  align-content: center;
  color: #fff;
  background-color: #4f9be1;
  transition: 0.3s ease all;
}
.required ::after {
  content: "*";
}
#dropzoneFile {
  display: none;
}

.identification-answer {
  width: 25%;
  margin-left: auto;
  align-content: right;
}

.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}
</style>